/**
 * ================================================================
 * Bisou Rivage — bisou-giftcard.js
 * ================================================================
 *
 * Page produit "Carte Cadeau" : selection format / cadre,
 * theme couleur dynamique (blobs), carte 3D au survol,
 * formulaire destinataire avec toggle date.
 *
 * Structure :
 *   1. Donnees & constantes (variants, themes, labels)
 *   2. Etat + init depuis le variant selectionne
 *   3. References DOM
 *   4. Helpers (formatMoney, getVariant, applyTheme)
 *   5. Update UI principal
 *   6. Ecouteurs d'evenements (format rows, cadre toggle)
 *   7. Initialisation
 *   8. Date toggle (recipient form)
 *   9. 3D tilt (mouse tracking, desktop only)
 *
 * ================================================================
 */
(function () {
  'use strict';

  /* ── 1. Parse variant data ── */
  var dataEl = document.getElementById('gc-variant-data');
  if (!dataEl) return;

  var variants = JSON.parse(dataEl.textContent);

  /* ── 1. Parse translated strings from Liquid bridge ── */
  var strEl = document.getElementById('gc-strings');
  var STR = strEl ? JSON.parse(strEl.textContent) : {};

  /* ── 1. Build 2D lookup (case-insensitive) ── */
  var variantMap = {};
  var formatLabels = {};
  var cadreLabels = {};

  variants.forEach(function (v) {
    var fKey = (v.option1 || '').trim().toLowerCase();
    var cKey = (v.option2 || '').trim().toLowerCase();
    if (!variantMap[fKey]) variantMap[fKey] = {};
    variantMap[fKey][cKey] = v;
    if (!formatLabels[fKey]) formatLabels[fKey] = v.option1;
    if (!cadreLabels[cKey]) cadreLabels[cKey] = v.option2;
  });

  /* ── 1. Color themes per format ── */
  var THEMES = {
    'petit': {
      bg: '#a1c4e0',
      c1: '#f26d5b', c2: '#e8f0f6', c3: '#8fb8d9', c4: '#ffffff',
      txt: '#1a1a1a'
    },
    'moyen': {
      bg: '#e0f7fa',
      c1: '#0077b6', c2: '#00b4d8', c3: '#90e0ef', c4: '#03045e',
      txt: '#1a1a1a'
    },
    'grand': {
      bg: '#0011ff',
      c1: '#F7E6E4', c2: '#06a46f', c3: '#ACBEE5', c4: '#f1f0f5',
      txt: '#1a1a1a'
    }
  };

  /* ── 1. Format labels from translations ── */
  var FORMAT_TIRAGE = {
    'petit': STR.tirage_petit || 'Petit tirage',
    'moyen': STR.tirage_moyen || 'Moyen tirage',
    'grand': STR.tirage_grand || 'Grand tirage'
  };

  var framedSuffix = STR.framed_suffix || '+ encadr\u00e9';
  var addToCartLabel = STR.add_to_cart || 'Ajouter au panier';

  /* ── 2. State ── */
  var state = { format: 'petit', cadre: 'sans cadre' };

  /* ── 2. Init state from selected variant ── */
  var hiddenInput = document.querySelector('#GiftCardForm input[name="id"]');
  if (hiddenInput) {
    var initialId = parseInt(hiddenInput.value, 10);
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === initialId) {
        state.format = (variants[i].option1 || '').trim().toLowerCase();
        state.cadre = (variants[i].option2 || '').trim().toLowerCase();
        break;
      }
    }
  }

  /* ── 3. DOM refs ── */
  var leftZone = document.querySelector('.gc-left');
  var priceEl = document.getElementById('gc-price');
  var cardType = document.getElementById('gc-card-type');
  var card = document.getElementById('gc-card');
  var atcBtn = document.querySelector('.gc-atc-btn');
  var atcText = atcBtn ? atcBtn.querySelector('.gc-atc-text') : null;
  var atcPrice = atcBtn ? atcBtn.querySelector('.gc-atc-price') : null;
  var formatRows = document.querySelectorAll('.gc-format-row');
  var segBtns = document.querySelectorAll('.gc-segment__btn');

  /* ── 4. Helpers ── */
  function formatMoney(cents) {
    return '\u20ac' + (cents / 100).toFixed(0);
  }

  function getVariant() {
    return variantMap[state.format] && variantMap[state.format][state.cadre];
  }

  /* ── 4. Apply color theme via inline styles ── */
  function applyTheme() {
    var theme = THEMES[state.format];
    if (!theme || !leftZone) return;
    leftZone.style.background = theme.bg;
    var blobs = leftZone.querySelectorAll('.gc-blob');
    var colors = [theme.c1, theme.c2, theme.c3, theme.c4];
    blobs.forEach(function (blob, idx) {
      if (colors[idx]) blob.style.background = colors[idx];
    });
  }

  /* ── 5. Update all UI ── */
  function update() {
    var variant = getVariant();
    if (!variant) return;

    if (hiddenInput) {
      hiddenInput.value = variant.id;
      hiddenInput.disabled = !variant.available;
    }

    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      if (atcText) atcText.textContent = addToCartLabel;
      if (atcPrice) atcPrice.textContent = ' \u2014 ' + formatMoney(variant.price);
    }

    formatRows.forEach(function (row) {
      var rowFmt = (row.dataset.format || '').trim().toLowerCase();
      var v = variantMap[rowFmt] && variantMap[rowFmt][state.cadre];
      var ps = row.querySelector('.gc-format-row__price');
      if (v && ps) ps.textContent = formatMoney(v.price);
    });

    if (cardType) {
      cardType.style.opacity = '0';
      setTimeout(function () {
        var label = FORMAT_TIRAGE[state.format] || state.format;
        var isCadre = state.cadre.indexOf('avec') !== -1;
        cardType.textContent = isCadre ? label + ' ' + framedSuffix : label;
        cardType.style.opacity = '1';
      }, 150);
    }

    applyTheme();

    if (card) {
      card.classList.toggle('gc-card--framed', state.cadre.indexOf('avec') !== -1);
    }

    if (variant.id && window.history && window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname + '?variant=' + variant.id);
    }

    var rf = document.querySelector('recipient-form');
    if (rf) rf.dataset.productVariantId = variant.id;
  }

  /* ── 6. Format row click ── */
  formatRows.forEach(function (row) {
    row.addEventListener('click', function () {
      state.format = (row.dataset.format || '').trim().toLowerCase();
      formatRows.forEach(function (r) { r.classList.toggle('active', r === row); });
      update();
    });
  });

  /* ── 6. Cadre toggle ── */
  segBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.cadre = (btn.dataset.cadre || '').trim().toLowerCase();
      segBtns.forEach(function (b) { b.classList.toggle('active', b === btn); });
      update();
    });
  });

  /* ── 7. Init ── */
  formatRows.forEach(function (row) {
    row.classList.toggle('active', (row.dataset.format || '').trim().toLowerCase() === state.format);
  });
  segBtns.forEach(function (btn) {
    btn.classList.toggle('active', (btn.dataset.cadre || '').trim().toLowerCase() === state.cadre);
  });
  update();

  /* ════════════════════════════════════════════════════════════
     8. DATE TOGGLE — Translated label, injected from gc-strings
     ════════════════════════════════════════════════════════════ */
  (function initDateToggle() {
    var recipientFields = document.querySelector('.gc-page .recipient-fields');
    if (!recipientFields) return;

    var allFields = recipientFields.querySelectorAll('.recipient-fields__field');
    var dateField = allFields.length > 0 ? allFields[allFields.length - 1] : null;
    if (!dateField) return;

    /* Inject date hint label (replaces old CSS ::before) */
    var dateFieldInner = dateField.querySelector('.field');
    if (dateFieldInner && !document.getElementById('gc-date-hint')) {
      var hintEl = document.createElement('div');
      hintEl.id = 'gc-date-hint';
      hintEl.className = 'gc-date-hint-label';
      hintEl.textContent = STR.date_hint || "Quand souhaitez-vous qu'il re\u00e7oive la carte ?";
      dateFieldInner.parentNode.insertBefore(hintEl, dateFieldInner);
    }

    /* Create toggle row */
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'gc-date-toggle';
    toggle.innerHTML = '<span class="gc-date-toggle__arrow">\u2192</span>' +
      '<span class="gc-date-toggle__icon">\uD83C\uDF81</span>' +
      '<span>' + (STR.date_toggle || 'Programmer pour une date sp\u00e9ciale ?') + '</span>' +
      '<span class="gc-date-toggle__check">\u2713</span>';

    dateField.parentNode.insertBefore(toggle, dateField);

    toggle.addEventListener('click', function () {
      var isOpen = dateField.classList.toggle('gc-date-visible');
      toggle.classList.toggle('active', isOpen);
    });
  })();

  /* ════════════════════════════════════════════════════════════
     9. 3D TILT — Mouse tracking (desktop only)
     ════════════════════════════════════════════════════════════ */
  var tilt = document.getElementById('gc-tilt');

  if (leftZone && tilt && !('ontouchstart' in window)) {
    var MAX_ROT = 16;
    var rAF = null;
    var targetRX = 0, targetRY = 0;
    var currentRX = 0, currentRY = 0;

    leftZone.addEventListener('mousemove', function (e) {
      var r = leftZone.getBoundingClientRect();
      var dx = (e.clientX - r.left - r.width / 2) / (r.width / 2);
      var dy = (e.clientY - r.top - r.height / 2) / (r.height / 2);
      targetRY = dx * MAX_ROT;
      targetRX = -dy * MAX_ROT;
      if (!rAF) animTilt();
    });

    leftZone.addEventListener('mouseleave', function () {
      targetRX = 0; targetRY = 0;
      if (!rAF) animTilt();
    });

    function animTilt() {
      currentRX += (targetRX - currentRX) * 0.1;
      currentRY += (targetRY - currentRY) * 0.1;
      tilt.style.transform = 'rotateX(' + currentRX.toFixed(2) + 'deg) rotateY(' + currentRY.toFixed(2) + 'deg)';
      var dist = Math.hypot(targetRX - currentRX, targetRY - currentRY);
      if (dist > 0.05) {
        rAF = requestAnimationFrame(animTilt);
      } else {
        rAF = null;
        tilt.style.transform = 'rotateX(' + targetRX + 'deg) rotateY(' + targetRY + 'deg)';
      }
    }
  }
})();
